@if (partnerTheme(); as theme) {
    <!-- Partner mode -->
    <div class="flex flex-col gap-y-6 rounded-[5px] border border-[#eeede9] bg-white p-8 md:p-4">
        <div class="flex flex-col gap-y-1">
            <div
                class="malou-text-34--bold md:malou-text-20--bold uppercase text-malou-text-title md:leading-tight"
                [style.font-family]="theme.titleFont ?? 'inherit'"
                [innerHTML]="
                    hasEnoughReviewsWithText()
                        ? ('maloupe.diagnostic_result.semantic_analysis.title.about_you_partner' | translate)
                        : ('maloupe.diagnostic_result.semantic_analysis.title.about_your_competitors_partner' | translate)
                "></div>
            @if (hasEnoughReviewsWithText()) {
                <div class="malou-text-12--regular md:malou-text-10--regular italic text-malou-text-title">
                    {{ 'maloupe.diagnostic_result.semantic_analysis.review_sample' | translate: { reviewCount: reviews().length } }}
                </div>
            }
        </div>
        @if (shouldDisplayChart()) {
            <div class="flex justify-around md:flex-col-reverse md:gap-2">
                @if (hasEnoughReviewsWithText() && hasEnoughCategories()) {
                    <app-tags-bar-chart
                        [segments]="reviewSegments()"
                        [positiveColor]="chartPositiveColor()"
                        [negativeColor]="chartNegativeColor()"></app-tags-bar-chart>
                    <app-tags-doughnut-chart
                        [segments]="reviewSegments()"
                        [positiveColor]="chartPositiveColor()"
                        [negativeColor]="chartNegativeColor()"></app-tags-doughnut-chart>
                } @else if (!hasEnoughReviewsWithText()) {
                    <div class="w-[60%]"><img alt="graph" [src]="'graph' | imagePathResolver: { folder: 'semantic-analysis' }" /></div>
                    <div class="w-[40%]">
                        <img alt="pie chart" [src]="'pie-chart' | imagePathResolver: { folder: 'semantic-analysis' }" />
                    </div>
                }
            </div>
        }
        <div class="flex items-center gap-x-4 rounded-[5px] bg-[#eeede9] px-8 py-3 md:gap-3 md:px-3">
            <img class="w-12 sm:!h-8 md:h-fit md:w-9" [alt]="Icon.TRUMPET" [src]="Icon.TRUMPET | imagePathResolver" />
            @if (hasEnoughReviewsWithText() && !!semanticAnalysisOverview()) {
                <span class="malou-text-12--bold text-malou-text-title">{{ semanticAnalysisOverview() }}</span>
            } @else {
                <span
                    class="malou-text-12--bold text-malou-text-title"
                    [innerHTML]="'maloupe.diagnostic_result.semantic_analysis.indication' | translate">
                </span>
            }
        </div>
    </div>
} @else {
    <!-- Default mode -->
    <div class="flex flex-col gap-x-7.5 rounded-[10px] border border-malou-primary bg-white p-12 md:p-4">
        <div
            class="malou-text-42--bold md:malou-text-20--bold font-passion-one uppercase text-malou-text-title md:leading-tight"
            [innerHTML]="
                hasEnoughReviewsWithText()
                    ? ('maloupe.diagnostic_result.semantic_analysis.title.about_you' | translate)
                    : ('maloupe.diagnostic_result.semantic_analysis.title.about_your_competitors' | translate)
            "></div>
        @if (hasEnoughReviewsWithText()) {
            <div class="malou-text-12--regular md:malou-text-10--regular mb-6 italic text-malou-text-title">
                {{ 'maloupe.diagnostic_result.semantic_analysis.review_sample' | translate: { reviewCount: reviews().length } }}
            </div>
        }
        @if (shouldDisplayChart()) {
            <div class="mb-10 flex justify-around md:flex-col-reverse md:gap-2">
                @if (hasEnoughReviewsWithText() && hasEnoughCategories()) {
                    <app-tags-bar-chart
                        [segments]="reviewSegments()"
                        [positiveColor]="chartPositiveColor()"
                        [negativeColor]="chartNegativeColor()"></app-tags-bar-chart>
                    <app-tags-doughnut-chart
                        [segments]="reviewSegments()"
                        [positiveColor]="chartPositiveColor()"
                        [negativeColor]="chartNegativeColor()"></app-tags-doughnut-chart>
                } @else if (!hasEnoughReviewsWithText()) {
                    <div class="w-[60%]"><img alt="graph" [src]="'graph' | imagePathResolver: { folder: 'semantic-analysis' }" /></div>
                    <div class="w-[40%]">
                        <img alt="pie chart" [src]="'pie-chart' | imagePathResolver: { folder: 'semantic-analysis' }" />
                    </div>
                }
            </div>
        }
        <div class="flex items-center gap-x-7 rounded-[10px] bg-malou-dark px-8 py-3 md:gap-3 md:px-3">
            <img class="w-12 sm:!h-8 md:h-fit md:w-9" [alt]="Icon.TRUMPET" [src]="Icon.TRUMPET | imagePathResolver" />
            @if (hasEnoughReviewsWithText() && !!semanticAnalysisOverview()) {
                <span class="malou-text-12--regular text-malou-text-title">{{ semanticAnalysisOverview() }}</span>
            } @else {
                <span
                    class="malou-text-12--regular text-malou-text-title"
                    [innerHTML]="'maloupe.diagnostic_result.semantic_analysis.indication' | translate">
                </span>
            }
        </div>
        @if (!isMalouRestaurant() && shouldDisplayChart()) {
            <div class="relative">
                <button
                    class="absolute bottom-[225px] left-0 right-0 m-auto flex h-12.5 w-fit items-center rounded-full bg-malou-blue px-6 py-3 text-white"
                    (click)="onTalkToAnExpert()">
                    <span class="malou-text-16--medium">{{ 'maloupe.diagnostic_result.semantic_analysis.cta' | translate }}</span>
                </button>
            </div>
        }
    </div>
}
